module.exports = __webpack_public_path__ + "assets/img/rolelabel-4aa6cf3c.png";